import * as React from 'react';
import { Field } from '../dynamic-input-field/DynamicInputField';

import style from './Agreement.module.css';

type AgreementProps = {
    api: any,
    field: Field
}

const Agreement = (props: AgreementProps) => {
    const [isValid, setValid] = React.useState(true);
    const [isChecked, setChecked] = React.useState(false);

    const validationStyling = isValid ? style.valid : style.invalid;

    props.field.validation = (e?: any) => {
        const checked = e ? e.target.checked : isChecked;
        if (props.field.required) {
            if(!checked){
                setValid(false);
                return false;
            }
        }
        setValid(true);
        return true;
    };

    const handleOnChange = (e: any) => {
        props.field.validation?.(e);
        setChecked(e.target.checked);
    };

    return (
        <div id={style.container} className={validationStyling}>
            <input id={style.checkbox} onChange={handleOnChange} type="checkbox" checked={isChecked}></input>
            <div id={style.text}>{props.field.text}</div>
        </div>
    )
};

export default Agreement;